import { westfieldConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function WestfieldPage() {
  return <CityPageTemplate config={westfieldConfig} />;
}